<template>
  <v-container fluid class="pa-2">
    <v-row>
      <v-col>
        <MyIncidentIcon
          v-if="details.icon"
          :icon="details.icon"
          :iconSize="30"
          class="px-1 pt-1 mr-1"
        ></MyIncidentIcon>
        <h2 class="mb-3">
          <div class="pull-left">{{ details.title }}</div>
          <div class="clearfix"></div>
        </h2>
        <div class="mb-1">
          <span class="application-heading">Incident Date:</span>
          {{ formattedIncidentDate }}
        </div>
        <div v-if="profile.incidentTimeEnabled" class="mb-1">
          <span class="application-heading">Incident Time:</span>
          {{ formattedIncidentTime }}
        </div>
        <div class="mb-1">
          <span class="application-heading">Category:</span>
          {{ details.category }}
        </div>
        <div class="mb-1">
          <span class="application-heading">Description:</span>
          {{ details.description }}
        </div>
        <div class="mb-1 countries-list">
          <span class="application-heading">Country:</span>
          <DetailsListItemCountryChip
            v-if="
              details.country.iso2Code &&
              details.country.name &&
              details.country.flagUrl
            "
            :key="details.country.countryAlpha2Code"
            :name="details.country.name"
            :code="details.country.iso2Code.toUpperCase()"
            :flagUrl="details.country.flagUrl"
            theme="dark"
          ></DetailsListItemCountryChip>
        </div>
        <div v-if="profile.severityEnabled" class="mb-1">
          <span class="application-heading">Severity:</span>
          {{ details.severity }}
        </div>
        <div v-if="details.customFields" class="mb-1">
          <div
            v-for="(value, key) in details.customFields"
            :key="key"
            class="mb-1"
          >
            <span class="application-heading">{{ key }}:</span>
            {{ value }}
          </div>
        </div>
        <div class="mb-1">
          <span class="application-heading">Created:</span>
          {{ details.createdAt }}
        </div>
        <div class="mb-1">
          <span class="application-heading">Updated:</span>
          {{ details.updatedAt }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { MODULE_PREFIX_HOME, MODULE_PREFIX_MY_INCIDENTS } from "@/store";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import lodashGet from "lodash/get";
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  name: "MyIncidentsDetails",
  components: {
    DetailsListItemCountryChip: () =>
      import("@/components/common/details/DetailsListItemCountryChip"),
    MyIncidentIcon: () => import("@/components/myIncidents/MyIncidentIcon"),
  },
  data: () => ({
    id: null,
    details: {
      title: null,
      incidentDate: null,
      category: null,
      description: null,
      country: {
        iso2Code: null,
        name: null,
        flagUrl: null,
      },
      icon: null,
      createdAt: null,
      updatedAt: null,
      customFields: null,
    },
  }),
  computed: {
    ...mapGetters({
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
      profile: MODULE_PREFIX_MY_INCIDENTS + "profile",
    }),
    formattedIncidentDate() {
      return this.details.incidentDate?.toLocaleDateString();
    },
    formattedIncidentTime() {
      if (!this.details.incidentTime) {
        return undefined;
      }
      return dayjs(
        `${dayjs(this.details.incidentDate).format("YYYY-MM-DD")}T${
          this.details.incidentTime
        }`
      ).format("HH:mm UTC");
    },
  },
  mounted() {
    if (
      this.detailsSidebar.selected === DETAIL_SIDEBAR_TYPES.myIncidents &&
      lodashGet(this.detailsSidebar, "features[0].properties.gid")
    ) {
      let properties = this.detailsSidebar.features[0].properties;
      this.details = {
        title: properties.title,
        description: properties.description,
        category: properties.category,
        icon: properties.icon,
        country: {
          iso2Code: properties.country_iso2_code,
          name: properties.country_name,
          flagUrl: properties.flag_url,
        },
        incidentDate: new Date(properties.incident_date),
        incidentTime: properties.incident_time,
        severity: properties.severity,
        createdAt: new Date(properties.created_at).toLocaleString(),
        updatedAt: new Date(properties.updated_at).toLocaleString(),
        customFields: this.parseCustomFields(properties.custom_fields),
      };
    }
  },
  methods: {
    parseCustomFields(customFieldsString) {
      if (!customFieldsString) {
        return {};
      }
      const enabledCustomFields = Object.entries(this.profile.customFields)
        .filter(([_, enabled]) => enabled)
        .map(([name, _]) => name);

      const customFields = JSON.parse(customFieldsString);
      return enabledCustomFields.reduce((acc, name) => {
        acc[name] = customFields[name];
        return acc;
      }, {});
    },
  },
};
</script>

<style scoped>
.countries-list {
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(auto-fit, 63px);
}
</style>
